import React from 'react';
import { Button } from '@material-ui/core';
import { createGame } from '../../redux/actions';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '../../components/paper';
import { useSelector } from 'react-redux';
import { GameHistory } from '../../components/gameHistory';

const useStyles = makeStyles(function(theme) {
  return {
    paper: {
      minHeight: '80px',
      margin: '12px 0'
    },
    mainButton: {
      height: '120px',
      width: '120px',
      margin: '28px 0'
    }
  };
});

export default () => {
  const dispatch = useDispatch();
  const gameListdata = useSelector(state => state.games);
  let history = useHistory();

  const createNewGame = () => {
    const temp = Date.now();
    dispatch(createGame(temp));
    history.push('add-players');
  };

  const classes = useStyles();

  return (
    <React.Fragment>
      <span className="center">
        <Button
          color="secondary"
          variant="contained"
          className={classes.mainButton}
          onClick={createNewGame}
        >
          NEW GAME
        </Button>
      </span>

     {false && <Paper className={classes.paper}>
        <span>List of past games</span>
        <GameHistory games={gameListdata.byId} />
      </Paper>}
    </React.Fragment>
  );
};
